module.exports = __webpack_public_path__ + "img/modal-document-clone.951a0185.svg";